import { VDialog } from 'vuetify/lib/components/VDialog';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VDialog,{attrs:{"width":"auto","persistent":""},on:{"input":function($event){return _vm.$emit('input', $event)}},model:{value:(_vm.isConfigCloudAccount),callback:function ($$v) {_vm.isConfigCloudAccount=$$v},expression:"isConfigCloudAccount"}},[_c('cloud-config')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }